// 全局工具 this.$global.xxx
let globalTools = {
	accAdd(arg1, arg2, fixedNo) {
		//js 加法计算 调用：accAdd(arg1,arg2) 返回值：arg1加arg2的精确结果
		var r1, r2, m;
		try {
			r1 = arg1.toString().split(".")[1].length;
		} catch (e) {
			r1 = 0;
		}
		try {
			r2 = arg2.toString().split(".")[1].length;
		} catch (e) {
			r2 = 0;
		}
		m = Math.pow(10, Math.max(r1, r2));
		let value = null;
		if (fixedNo) {
			value = ((arg1 * m + arg2 * m) / m).toFixed(fixedNo);
		} else {
			value = ((arg1 * m + arg2 * m) / m).toFixed(2);
		}
		return value;
	},
	subtr(arg1, arg2, fixedNo) {
		//js 减法计算 subtr(arg1,arg2) 返回值：arg1减arg2的精确结果
		var r1, r2, m, n;
		try {
			r1 = arg1.toString().split(".")[1].length;
		} catch (e) {
			r1 = 0;
		}
		try {
			r2 = arg2.toString().split(".")[1].length;
		} catch (e) {
			r2 = 0;
		}
		m = Math.pow(10, Math.max(r1, r2));
		n = r1 >= r2 ? r1 : r2;
		let value = null;
		if (fixedNo) {
			value = ((arg1 * m - arg2 * m) / m).toFixed(fixedNo);
		} else {
			value = ((arg1 * m - arg2 * m) / m).toFixed(2);
		}
		return value;
	},
	accMul(arg1, arg2) {
		//js 乘法函数 调用：accMul(arg1,arg2) 返回值：arg1乘以arg2的精确结果
		var m = 0,
			s1 = arg1 ? arg1.toString() : "",
			s2 = arg2 ? arg2.toString() : "";
		try {
			m += s1.split(".")[1].length;
		} catch (e) {}
		try {
			m += s2.split(".")[1].length;
		} catch (e) {}
		return (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) / Math.pow(10, m);
	},
	accDiv(arg1, arg2) {
		//js 除法函数 accDiv(arg1,arg2) 返回值：arg1除以arg2的精确结果
		var t1 = 0,
			t2 = 0,
			r1,
			r2;
		try {
			t1 = arg1.toString().split(".")[1].length;
		} catch (e) {}
		try {
			t2 = arg2.toString().split(".")[1].length;
		} catch (e) {}
		r1 = Number(arg1.toString().replace(".", ""));
		r2 = Number(arg2.toString().replace(".", ""));
		return (r1 / r2) * Math.pow(10, t2 - t1);
	},
	// 重量单位映射
	weightUnitMap: {
		克: 1,
		千克: 1000,
		斤: 500,
		公斤: 1000,
		吨: 1000 * 1000,
		g: 1,
		G: 1,
		kg: 1000,
		Kg: 1000,
		KG: 1000,
		t: 1000 * 1000,
		T: 1000 * 1000,
	},
	/**
	 * 重量单位转换  demo  _this.convertWeight(goodsQty,goodsUnit)
	 * data 数据值
	 * beforeUnit 原单位 默认 '千克'
	 * afterUnit 转换后单位 默认'千克'
	 */
	convertWeight(data, beforeUnit = "千克", afterUnit = "千克") {
		let accMul = this.accMul(this.weightUnitMap[beforeUnit], data, 3);
		let accDiv1 = this.accDiv(accMul, this.weightUnitMap[afterUnit], 3);
		return accDiv1;
	},
	// _this.getTotalData(data)
	// 计算出总重量总体积总包数总货品量
	// demo 重量 1400kg 体积 1400 方 货品量 1400KG 包装数30
	getTotalData(data, settings) {
		let _this = this;
		let handoverDetailsVos = data;
		let packingQtyCount = 0,
			packingWeightCount = 0,
			packingVolumeCount = 0,
			goodsQtyCount = 0;
		let defaultLightRate = settings.P_LIGHT_RATE || 3;

		for (let i in handoverDetailsVos) {
			let packingQty = handoverDetailsVos[i].packingQty ? handoverDetailsVos[i].packingQty * 1 : null;
			let packingWeight = handoverDetailsVos[i].packingWeight ? handoverDetailsVos[i].packingWeight * 1 : null;
			let packingVolume = handoverDetailsVos[i].packingVolume ? handoverDetailsVos[i].packingVolume * 1 : null;
			let goodsQty = handoverDetailsVos[i].goodsQty ? handoverDetailsVos[i].goodsQty * 1 : null;
			let goodsUnit = handoverDetailsVos[i].goodsUnit;
			if (goodsQty) {
				goodsQtyCount += goodsQty;
			}
			let calcWeightValue;
			// 计算包装数
			if (packingQty) {
				packingQtyCount = _this.accAdd(packingQtyCount, packingQty, 3);
			}
			// 计算包装重量
			if (packingWeight && (packingQty || packingQty === 0)) {
				packingWeightCount = _this.accAdd(packingWeightCount, _this.accMul(packingQty, packingWeight, 3), 3);
			} else if (goodsQty && goodsUnit && this.weightUnitMap[goodsUnit]) {
				calcWeightValue = _this.convertWeight(goodsQty, goodsUnit).toFixed(3) * 1; // 保留3位小数
				packingWeightCount = _this.accAdd(calcWeightValue, packingWeightCount, 3);
			}
			// 计算体积
			if (packingVolume && (packingQty || packingQty === 0)) {
				let num1 = _this.accMul(packingQty, packingVolume, 3);
				packingVolumeCount = _this.accAdd(packingVolumeCount, num1, 3);
			} else if (calcWeightValue) {
				let num1 = _this.accMul(calcWeightValue, defaultLightRate);
				let num2 = _this.accDiv(num1, 1000);
				packingVolumeCount = _this.accAdd(packingVolumeCount, num2, 3);
			}
		}
		let result = { packingWeightCount, packingVolumeCount, packingQtyCount, goodsQtyCount };
		return result;
	},
};
export default globalTools;



// WEBPACK FOOTER //
// ./src/config/globalTools.js